export const getReminderFlowId = state => state.reminderFlows.reminderFlow.id;
export const getReminderFlowEmail = state => state.reminderFlows.reminderFlow.email;
export const getReminderFlowData = state => state.reminderFlows.reminderFlow;
export const reminderFlowIsFetching = state => state.reminderFlows.loading;